/**
 * Add CSS modifiers to base class.
 */
export default (base: string, mods: string[] = []) =>
  mods.length === 0 ? base : `${base}--${mods.join('--')}`
